'use strict';

angular.module('mobile-apps')
	.controller('UploadScreenshotModalController', [
		'$scope',
		'uploadInfo',
		'$stateParams',
		'EntryMain',
		'AvailableLanguages',
		'$modalInstance',
		function (
			$scope,
			uploadInfo,
			$stateParams,
			EntryMain,
			AvailableLanguages,
			$modalInstance
		) {
			$scope.fileName = uploadInfo.file.name;
			$scope.availableLanguages = {};
			$scope.languages = {};

			$scope.selectedLanguage = '';
			$scope.useOCR = false;

			$scope.properties = [
				{
					key: 'bundleVersion',
					name: 'Version',
					value: '',
					defaultValue: '1.0',
					overwriteEnabled: false
				},
				{
					key: 'deviceModel',
					name: 'Device',
					value: 'manual',
					defaultValue: 'manual',
					overwriteEnabled: false
				},
				{
					key: 'operatingSystem',
					name: 'OS',
					value: 'manual',
					defaultValue: 'manual',
					overwriteEnabled: false
				}
			];


			/**
			 * Returns the propertyData of they given key
			 * @param key The key of the property
			 * @returns {*}
			 */
			var getPropertyData = function(key) {
				for (var i=0;i<$scope.properties.length;i++) {
					if ($scope.properties[i].key === key) {
						return $scope.properties[i];
					}
				}
				return undefined;
			};


            $scope.useOCRCheckBoxChanged = function(checked) {
                $scope.useOCR = checked;
            };


			/**
			 * Activates/Deactivates the input field accordingly when checkbox
			 * get toggled
			 * @param key The key of the input field
			 */
			$scope.toggleCheckbox = function(key) {
				var propertyData = getPropertyData(key);

				if (propertyData && propertyData.overwriteEnabled === false) {
					propertyData.value = propertyData.defaultValue;
				}
			};


			/**
			 * Close modal
			 */
			$scope.close = function() {
				$modalInstance.dismiss();
			};


			/**
			 * Start uploading the screenshot
			 */
			$scope.startUpload = function () {
				// Get the property values and return them
				var returnData = {};
				for (var i=0;i<$scope.properties.length;i++) {
					returnData[$scope.properties[i].key] = $scope.properties[i].value;
				}

                returnData.deviceLanguageLong = Object.keys($scope.availableLanguages).find(langCode => $scope.availableLanguages[langCode] === $scope.selectedLanguage);
				returnData.useOCR = $scope.useOCR;


				$modalInstance.close(returnData);
			};


			/**
			 * Initialize the property values
			 */
			function init() {
				// Initialize values with defaults
				for (var i=0;i<$scope.properties.length;i++) {
					$scope.properties[i].value = $scope.properties[i].defaultValue;
				}

				// Make sure that the app data, especially the languages are loaded
				EntryMain.loadMobileApp($stateParams.mobileAppId, false, function() {
					// Get the different languages to choose from and set current
					// language as default
					AvailableLanguages.get(function(data) {
						$scope.availableLanguages = data;
						var languageKey = EntryMain.languages[$stateParams.languageId].name;
						$scope.selectedLanguage = $scope.availableLanguages[languageKey];

						$scope.languages = EntryMain.languages;
					});
				});
			}


			init();
		}
	]);
